export const PAGE_SIZE = 20
export const PAGE_SIZE_OPTIONS = [5, 10, 20, 40, 50, 60, 80, 100]